import { render } from "./MiscountModal.vue?vue&type=template&id=2a655a50"
import script from "./MiscountModal.vue?vue&type=script&lang=js"
export * from "./MiscountModal.vue?vue&type=script&lang=js"
script.render = render

export default script